import { Check, Circle, Clock } from 'lucide-react';

type PhaseTimestamps = {
  order_placed_at: string | null;
  purchased_at: string | null;
  arrived_warehouse_at: string | null;
  tracking_assigned_at: string | null;
  delivered_at: string | null;
  stage: string;
  is_delayed: boolean;
};

const PHASES = [
  { key: 'order_placed_at',     label: 'Görüldü',          desc: 'Seller ID sistemde' },
  { key: 'purchased_at',        label: 'Satın alındı',      desc: 'Buyer ID atandı' },
  { key: 'arrived_warehouse_at',label: 'Depoda',            desc: 'Depoya teslim oldu' },
  { key: 'tracking_assigned_at',label: 'Kargoya verildi',   desc: 'Tracking atandı' },
  { key: 'delivered_at',        label: 'Teslim edildi',     desc: 'Müşteri aldı' },
] as const;

/** 5 aşamalı faz timeline (yatay).
 *  Aşama 0: order_placed_at
 *  Aşama 1: purchased_at
 *  Aşama 2: arrived_warehouse_at
 *  Aşama 3: tracking_assigned_at
 *  Final: delivered_at
 *
 *  Dolu olan aşamalar yeşil (✓ + tarih). Boş olanlar gri (○).
 */
export default function PhaseTimeline({ ts }: { ts: PhaseTimestamps }) {
  if (ts.stage === 'iptal' || ts.stage === 'iade') {
    return (
      <div className="bg-rose-50 border border-rose-200 rounded p-3 text-sm text-rose-700">
        Bu sipariş <strong>{ts.stage === 'iptal' ? 'iptal' : 'iade'}</strong> aşamasında — faz akışı durdu.
      </div>
    );
  }

  return (
    <ol className="space-y-2">
      {PHASES.map((p, idx) => {
        const value = ts[p.key as keyof PhaseTimestamps] as string | null;
        const filled = !!value;
        const next = PHASES[idx + 1];
        const nextValue = next ? (ts[next.key as keyof PhaseTimestamps] as string | null) : null;
        const isCurrent = filled && !nextValue;
        return (
          <li key={p.key} className="flex items-start gap-3">
            <div className="flex flex-col items-center pt-1">
              <div className={
                'w-6 h-6 rounded-full flex items-center justify-center ' +
                (filled
                  ? (isCurrent && ts.is_delayed
                      ? 'bg-red-100 text-red-700'
                      : isCurrent
                      ? 'bg-amber-100 text-amber-700'
                      : 'bg-emerald-100 text-emerald-700')
                  : 'bg-slate-100 text-slate-400')
              }>
                {filled ? <Check className="w-3.5 h-3.5" /> : isCurrent ? <Clock className="w-3.5 h-3.5" /> : <Circle className="w-3 h-3" />}
              </div>
              {idx < PHASES.length - 1 && (
                <div className={'w-px h-6 ' + (filled ? 'bg-emerald-200' : 'bg-slate-200')} />
              )}
            </div>
            <div className="flex-1 min-w-0 pb-2">
              <div className="text-sm font-medium text-slate-900">{p.label}</div>
              <div className="text-xs text-slate-500">{p.desc}</div>
              <div className={'text-xs mt-0.5 ' + (filled ? 'text-slate-700' : 'text-slate-300')}>
                {filled ? new Date(value!).toLocaleString('tr-TR') : 'henüz değil'}
                {isCurrent && ts.is_delayed && (
                  <span className="ml-2 inline-block px-1.5 py-0.5 rounded text-[10px] bg-red-100 text-red-700 font-medium">
                    GEÇ
                  </span>
                )}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
